import React from 'react';

export const MovieCardLazy = React.lazy(() => import('./MovieCard'));
